import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getLocaleByStoredLocaleData,
  getUserLocaleVocabularyByLocale,
} from './localization.utils';
import { LOCALE_LOCAL_STORAGE_KEY } from './localization.constants';
import { safelyGetItem } from 'utils/localStorage';
import {
  TVocabularyGetListBE,
  TVocabularyGetListLocalePath,
} from 'api/localization/localization.types';
import createHttpClient from 'store/httpClient';
import { vocabularyEndPoints } from 'api/localization/constants';
import { TLocalizationData } from './localization.types';

export const getLocalizationList = createAsyncThunk<
  TLocalizationData,
  { locale?: TVocabularyGetListLocalePath }
>(
  'localization/getLocalizationList',
  async ({ locale }, { rejectWithValue }) => {
    try {
      const storedLocale = safelyGetItem(LOCALE_LOCAL_STORAGE_KEY);
      const currentLocale = getLocaleByStoredLocaleData(storedLocale);

      const httpClient = createHttpClient(undefined);
      const localizationList = await httpClient.get<TVocabularyGetListBE>(
        vocabularyEndPoints.getList(locale)
      );
      const staticVocabulary = getUserLocaleVocabularyByLocale(currentLocale);

      console.log(staticVocabulary);

      return {
        translations: {
          ...staticVocabulary,
          ...(localizationList?.data ?? {}),
        },
        locale: currentLocale,
      };
    } catch {
      return rejectWithValue({ message: 'Error fetching locale data' });
    }
  }
);
